<template>
  <div class="l-row--t64 l-row--t128l module">
		<div class="g-row" :class="[
			{ 's--h-start': data.target.align == 0 },
			{ 's--h-end': data.target.align == 2 }
		]">
			<div class="" :class="[
				{'g-col--7 g-col--5s': data.target.itemType == 'iphone'},
				{'g-col--13 g-col--11l g-col--5s': data.target.itemType == 'tablet-h'},
				{'g-col--9 g-col--5s': data.target.itemType == 'tablet-v'},
			]">
				<Device class="c-dvc--solo" :target="data.target" />
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "fxjs";
import { computed, ref, reactive, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";
import Device from "@/parts/work-view/_Device.vue";

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture,
		Device
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>